export default __webpack_public_path__ + "static/tf-09110370c5321c0a27dd728c17271d28.jpeg";